module.exports = __webpack_public_path__ + "static/media/calendar-blue.3bd6bbe3.svg";